import { PUT_PORTOFOLIO_START } from '../../types';

export const put_portofolio = (payload) => ({
  type: PUT_PORTOFOLIO_START,
  payload,
});
